// extracted by mini-css-extract-plugin
export default {"invalidDataError":"BlogType_invalidDataError__N4f1q"};